module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Tag 标签",
      "description": "用于标记和选择。",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础用法",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode1
    }
  }, [_c('template', {
    slot: "description"
  }), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-tag', [_vm._v("标签一")]), _vm._v(" "), _c('vm-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("标签二")]), _vm._v(" "), _c('vm-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("标签三")]), _vm._v(" "), _c('vm-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("标签四")]), _vm._v(" "), _c('vm-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("标签五")]), _vm._v(" "), _c('vm-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("标签六")])], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      对你的代码进行描述\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "可移除标签",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode2
    }
  }, [_c('template', {
    slot: "description"
  }), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('vm-tag', {
      key: tag.name,
      attrs: {
        "closable": true,
        "type": tag.type,
        "tagclass": "tagclass"
      }
    }, [_vm._v("\n          " + _vm._s(tag.name) + "\n        ")])
  }))]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      设置closable属性可以定义一个标签是否可移除。默认的标签移除时会附带渐变动画，如果不想使用，可以设置close-transition属性，它接受一个Boolean，true 为关闭。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "动态编辑标签",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode3
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n      动态编辑标签可以通过点击标签关闭按钮后触发的 close 事件来实现\n    ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('vm-tag', {
      key: tag,
      attrs: {
        "closable": true,
        "close-transition": false,
        "tagclass": "tagclass"
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag) + "\n        ")])
  }), _vm._v(" "), _c('vm-input', {
    ref: "saveTagInput",
    attrs: {
      "inputclass": "newTagInput",
      "placeholder": "+NewTag"
    },
    on: {
      "enter": _vm.handleInputConfirm,
      "blur": _vm.handleInputConfirm
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 2)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      实现添加删除\n    ")])], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "attributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#attributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n      Attributes\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("主题")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("primary/gray/success/warning/danger")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("closable")]), _vm._v(" "), _c('td', [_vm._v("是否可关闭")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("close-transition")]), _vm._v(" "), _c('td', [_vm._v("是否禁用渐变动画")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("hit")]), _vm._v(" "), _c('td', [_vm._v("是否有边框描边")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', [_vm._v("背景色")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("tagclass")]), _vm._v(" "), _c('td', [_vm._v("标签类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "event"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#event",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n      Events\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', [_vm._v("关闭tag时触发的事件")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0417eb1e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0417eb1e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 16
// module chunks = 0